import Header from '@components/Header';
import { ICON_DEFAULT_COLOR } from '@constants/icons';
import ReceiptIcon from '@icons/Receipt';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Props {
    orderId: string;
}

function OrderHeader({ orderId }:Props) {
    const { t } = useTranslation('orderLog');
    const { push } = useFlow();
    return (
        <Header title={t('header.title')}
            trailing={
                <ReceiptIcon color={ICON_DEFAULT_COLOR}
                    id='order-receipt-button'
                    size={24}
                    onClick={() => {
                        push('OrderReceiptActivity', { orderId });
                    }}/>
            }
        />
    );
}

export default OrderHeader;
